var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 20.3428C3.525 20.3428 3.20833 20.2011 2.925 19.9178C2.64167 19.6344 2.5 19.3178 2.5 18.9678V7.16777C2.5 6.80111 2.65 6.46777 2.95 6.16777C3.25 5.86777 3.58333 5.71777 3.95 5.71777H10.775L12.025 6.96777H20.05C20.3833 6.96777 20.6792 7.08444 20.9375 7.31777C21.1958 7.55111 21.3583 7.81777 21.425 8.11777H11.525L10.275 6.86777H3.95C3.85 6.86777 3.77083 6.89694 3.7125 6.95527C3.65417 7.01361 3.625 7.08444 3.625 7.16777V18.8928C3.625 18.9761 3.64583 19.0386 3.6875 19.0803C3.72917 19.1219 3.775 19.1594 3.825 19.1928L6.325 9.74277H23.25L20.7 19.2928C20.6 19.6594 20.4292 19.9261 20.1875 20.0928C19.9458 20.2594 19.6333 20.3428 19.25 20.3428H3.875ZM5.025 19.2178H19.55L21.7 10.8928H7.175L5.025 19.2178ZM5.025 19.2178L7.175 10.8928L5.025 19.2178ZM3.625 8.11777V6.86777V8.11777Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolderOpen);
export default __webpack_public_path__ + "static/media/icon_folder_open.71311ad2.svg";
export { ForwardRef as ReactComponent };